/* ==========================================================================
   KOTT Reveal — scroll-triggered entrance animations.
   Companion to kott-reveal.css. Uses IntersectionObserver to add the
   .kreveal--visible class once an element enters the viewport.

   - Elements with [data-kreveal] reveal themselves.
   - Elements with [data-kreveal-children] reveal each direct child in a
     sequenced stagger (via the --kreveal-i custom property).
   - Once revealed, observers disconnect for that element to save work.
   - Skips entirely under prefers-reduced-motion (CSS already neutralizes the
     resting state, so content is fully visible immediately).
   ========================================================================== */
(function () {
  'use strict';

  if (window.kottReduceMotion ? window.kottReduceMotion() : window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    // CSS already sets everything to its visible state for reduced motion.
    return;
  }

  if (typeof IntersectionObserver === 'undefined') {
    // Fallback: mark everything visible immediately.
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('[data-kreveal], [data-kreveal-children]').forEach(function (el) {
        el.classList.add('kreveal--visible');
      });
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('kreveal--visible');
      observer.unobserve(el);
    });
  }, {
    threshold: 0.12,
    // Reveal a bit before the element fully enters — feels natural.
    rootMargin: '0px 0px -8% 0px'
  });

  function indexChildren(parent) {
    var i = 0;
    Array.prototype.forEach.call(parent.children, function (child) {
      child.style.setProperty('--kreveal-i', String(i++));
    });
  }

  function observeAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-kreveal]').forEach(function (el) {
      if (el.classList.contains('kreveal--visible')) return;
      observer.observe(el);
    });
    scope.querySelectorAll('[data-kreveal-children]').forEach(function (el) {
      if (el.classList.contains('kreveal--visible')) return;
      indexChildren(el);
      observer.observe(el);
    });
  }

  function init() {
    observeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor support: re-scan when sections are reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });
})();
